import VideoClassificationTip from '../VideoClassificationTip';
import { useVideoDetailInfo } from './useVideoDetailInfo';
import { Video } from './types';
import styles from './VideoDetailInfo.module.css';
import { ExtendedVideo } from '../VideoClassificationTip/types';

interface VideoDetailDescriptionProps {
  video: Video;
  tagArray?: string[];
  handleTagClick: (tag: string) => void;
}

const VideoDetailDescription = ({
  video,
  tagArray,
  handleTagClick,
}: VideoDetailDescriptionProps) => {
  const {
    expanded,
    setExpanded,
    isSP,
    displayedDescription,
    isLong,
    convertUrlsToLinks,
    handleSpecialtyButtonClick,
  } = useVideoDetailInfo(video, handleTagClick);

  const hasSpecialty = video.specialty && video.specialty.name;
  const hasTags = tagArray && tagArray.length > 0;
  const hasDescription = displayedDescription && displayedDescription.trim();

  if (!hasSpecialty && !hasTags && !hasDescription) return null;

  return (
    <div className={styles['VideoDetailInfo']}>
      {/* 診療科 */}
      {hasSpecialty && (
        <div
          className={`${styles['VideoDetailInfo-tagArea']} ${
            isSP
              ? styles['VideoDetailInfo-tagArea--sp']
              : styles['VideoDetailInfo-tagArea--pc']
          }`}
        >
          <button
            type="button"
            className={styles['VideoDetailInfo-specialtyButton']}
            onClick={handleSpecialtyButtonClick}
          >
            <VideoClassificationTip video={video as ExtendedVideo} />
          </button>
        </div>
      )}

      {/* タグ群 */}
      {hasTags && (
        <div
          className={`${styles['VideoDetailInfo-tagContainer']} ${
            isSP
              ? styles['VideoDetailInfo-tagContainer--sp']
              : styles['VideoDetailInfo-tagContainer--pc']
          }`}
        >
          {tagArray!.map((tag, idx) => {
            const trimmed = tag.trim();
            if (!trimmed) return null;
            return (
              <button
                key={idx}
                onClick={() => handleTagClick(trimmed)}
                className={`${styles['VideoDetailInfo-tagButton']} ${
                  isSP ? styles['VideoDetailInfo-tagButton--sp'] : ''
                }`}
                title={trimmed}
              >
                <span className={styles['VideoDetailInfo-tagButtonSpan']}>
                  {trimmed}
                </span>
              </button>
            );
          })}
        </div>
      )}

      {/* 説明文 */}
      {hasDescription && (
        <div
          className={`${styles['VideoDetailInfo-descriptionContainer']} ${styles['VideoDetailInfo-descriptionContainer--hasContent']}`}
        >
          <div
            className={`${styles['VideoDetailInfo-description']} ${
              isSP
                ? styles['VideoDetailInfo-description--sp']
                : `${styles['VideoDetailInfo-description--pc']} ${
                    expanded
                      ? styles['VideoDetailInfo-description--pcExpanded']
                      : styles['VideoDetailInfo-description--pcCollapsed']
                  }`
            }`}
          >
            {convertUrlsToLinks(displayedDescription)}
          </div>
          {isLong && (
            <button
              type="button"
              className={styles['VideoDetailInfo-toggleDescription']}
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? '折りたたむ' : '続きを読む'}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default VideoDetailDescription;
